import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { SettingsModal } from './SettingsModal';
import { jsx as _jsx } from "react/jsx-runtime";
export var openSettingsModal = function openSettingsModal(params) {
  var modalRoot = document.createElement('div');
  document.body.appendChild(modalRoot);
  var root = createRoot(modalRoot);

  var onHide = function onHide() {
    root.unmount();
    document.body.removeChild(modalRoot);
  };

  root.render( /*#__PURE__*/_jsx(SettingsModal, _objectSpread({
    show: true,
    onHide: onHide
  }, params)));
};